import { observer } from 'mobx-react';
import { Component } from 'react';
import { withCheckoutStore } from '../../context';
import { DELIVERY_TYPES, DELIVERY_TYPE_PICKER_OPTION } from 'src/constants/deliveryTypes';
import { appStore } from 'src/mobx/appStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import TabPicker from 'src/view/components/Controls/Pickers/TabPicker/TabPicker';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { CheckoutStore } from '~/mobx/checkoutStore';

// @ts-ignore
@withCheckoutStore
@observer
export default class CheckoutDeliveryType extends Component<{ checkoutStore?: CheckoutStore }, {}> {
  get checkoutStore() {
    return this.props.checkoutStore!;
  }

  get activeType() {
    let _active: DELIVERY_TYPE_PICKER_OPTION | undefined = DELIVERY_TYPE_PICKER_OPTION.PICKUP;
    switch (true) {
      case !this.checkoutStore.dependencies.user.phone && appStore.settings?.is_cc_zone_orders:
        _active = undefined;
        break;
      case this.checkoutStore.params.is_curbside && this.checkoutStore.params.delivery_type === DELIVERY_TYPES.PICKUP:
        _active = DELIVERY_TYPE_PICKER_OPTION.CURBSIDE;
        break;
      case Boolean(this.checkoutStore.params.is_dinein):
        _active = DELIVERY_TYPE_PICKER_OPTION.DINE_IN;
        break;
      case this.checkoutStore.params.delivery_type === DELIVERY_TYPES.PICKUP:
        _active = DELIVERY_TYPE_PICKER_OPTION.PICKUP;
        break;
      case this.checkoutStore.params.delivery_type === DELIVERY_TYPES.DELIVERY:
        _active = DELIVERY_TYPE_PICKER_OPTION.DELIVERY;
        break;
      default:
        break;
    }
    return _active;
  }

  get deliveryTypes(): IPickerOption[] {
    const delivery_types = [];
    if (appStore.settings?.is_cc_zone_orders) {
      return [
        { value: DELIVERY_TYPE_PICKER_OPTION.PICKUP, label: 'txt_pickup' },
        { value: DELIVERY_TYPE_PICKER_OPTION.CURBSIDE, label: 'curbside' },
        { value: DELIVERY_TYPE_PICKER_OPTION.DELIVERY, label: 'txt_delivery' },
        { value: DELIVERY_TYPE_PICKER_OPTION.DINE_IN, label: 'dine_in' },
      ];
    }
    if (
      this.checkoutStore.dependencies.branch.delivery_type === DELIVERY_TYPES.BOTH ||
      this.checkoutStore.dependencies.branch.delivery_type === DELIVERY_TYPES.PICKUP
    ) {
      delivery_types.push({ value: DELIVERY_TYPE_PICKER_OPTION.PICKUP, label: 'txt_pickup' });
      if (this.checkoutStore.dependencies.branch.is_curbside) {
        delivery_types.push({ value: DELIVERY_TYPE_PICKER_OPTION.CURBSIDE, label: 'curbside' });
      }
    }
    if (
      this.checkoutStore.dependencies.branch.delivery_type === DELIVERY_TYPES.BOTH ||
      this.checkoutStore.dependencies.branch.delivery_type === DELIVERY_TYPES.DELIVERY
    ) {
      delivery_types.push({ value: DELIVERY_TYPE_PICKER_OPTION.DELIVERY, label: 'txt_delivery' });
    }
    if (this.checkoutStore.dependencies.branch.is_emenu && appStore.settings?.is_emenu) {
      delivery_types.push({ value: DELIVERY_TYPE_PICKER_OPTION.DINE_IN, label: 'dine_in' });
    }
    return delivery_types;
  }

  onChange = (active: number) => {
    if (active === DELIVERY_TYPE_PICKER_OPTION.PICKUP) {
      this.checkoutStore.toggleCurbside(0, true);
      this.checkoutStore.toggleDineIn(0, true);
      this.checkoutStore.changeDeliveryType(DELIVERY_TYPES.PICKUP);
    } else if (active === DELIVERY_TYPE_PICKER_OPTION.CURBSIDE) {
      this.checkoutStore.toggleCurbside(1, true);
      this.checkoutStore.toggleDineIn(0, true);
      this.checkoutStore.changeDeliveryType(DELIVERY_TYPES.PICKUP);
    } else if (active === DELIVERY_TYPE_PICKER_OPTION.DELIVERY) {
      this.checkoutStore.toggleCurbside(0, true);
      this.checkoutStore.toggleDineIn(0, true);
      this.checkoutStore.changeDeliveryType(DELIVERY_TYPES.DELIVERY);
    } else if (active === DELIVERY_TYPE_PICKER_OPTION.DINE_IN) {
      this.checkoutStore.toggleCurbside(0, true);
      this.checkoutStore.toggleDineIn(1, true);
      this.checkoutStore.defineDinein(this.checkoutStore.dependencies.branch);
      this.checkoutStore.changeDeliveryType(DELIVERY_TYPES.PICKUP);
    }
  };

  render() {
    return (
      <div className="d-flex align-items-center mb-3">
        <Text type={TEXT.ORDER_FIELD} text="order_type" />
        <TabPicker
          value={this.activeType}
          options={this.deliveryTypes}
          onChange={this.onChange}
          error={this.checkoutStore.validatorErrors.delivery_type}
          disabled={!this.checkoutStore.isDraft || (!this.checkoutStore.dependencies.branch.id && !appStore.settings?.is_cc_zone_orders)}
        />
      </div>
    );
  }
}
